import React, { useEffect, useState } from 'react'
import { CBadge, CButton, CSmartTable } from '@coreui/react-pro'
import moment from 'moment'
import ToastComponent from 'src/components/common/TaostComponent.js'
import AdsManagerService from 'src/service/AdsManagerService'

const GamePromoTable = ({
  users,
  fetchUsers,
  setActivePage,
  setItemsPerPage,
  setColumnFilter,
  setColumnSorter,
  itemsPerPage,
  activePage,
  columnFilter,
  columnSorter,
}) => {
  const [loading, setLoading] = useState(false)

  const columns = [
    {
      label: 'Logo',
      key: 'logo',
      filter: false,
      sorter: false,
    },
    { label: 'Promo Title', filter: true, key: 'title' },
    { label: 'Promo Label', filter: true, key: 'promo_label' },
    { label: 'Promo Validity', filter: false, key: 'validity_date' },
    {
      label: 'Promo Start Date',
      filter: false,
      key: 'schedule_start_date',
    },
    {
      label: 'Promo End Date',
      filter: false,
      key: 'schedule_end_date',
    },
    { label: 'Status', filter: false, key: 'is_active', _style: { width: '20%' } },
    {
      key: 'actions',
      label: 'Actions',
      _style: { width: '1%' },
      filter: false,
      sorter: false,
    },
  ]

  const getBadge = (status) => {
    switch (status) {
      case 1:
        return 'success'
      case 0:
        return 'warning'
      default:
        return 'primary'
    }
  }

  const handleStatus = (id, status) => {
    setLoading(true)
    AdsManagerService.updateStatus(id, status)
      .then((res) => {
        if (res.status === 200) {
          fetchUsers()
          ToastComponent(res.message, 'success')
        } else {
          ToastComponent(res.message, 'error')
        }
      })
      .catch((e) => {
        console.log('Catch Block', e)
      })
      .finally(() => {
        setLoading(false)
      })
  }

  useEffect(() => {
    fetchUsers()
  }, [activePage, columnFilter, columnSorter, itemsPerPage, fetchUsers])

  return (
    <CSmartTable
      columns={columns}
      columnFilter={{
        external: true,
      }}
      columnSorter={{
        external: true,
      }}
      scopedColumns={{
        logo: (item) => (
          <td>
            {item.logo && (
              <img
                src={`${process.env.REACT_APP_API_URL}uploads/ads/${item.logo}`}
                alt="promo"
                width="50"
                height="50"
              />
            )}
          </td>
        ),
        validity_date: (item) => <td>{moment(item.validity_date).format('D.MM.YYYY')}</td>,
        schedule_start_date: (item) => (
          <td>{moment(item.schedule_start_date).format('D.MM.YYYY')}</td>
        ),
        schedule_end_date: (item) => <td>{moment(item.schedule_end_date).format('D.MM.YYYY')}</td>,
        is_active: (item) => (
          <td>
            <CBadge color={getBadge(item.is_active)}>
              {item.is_active === 1 ? 'Activated' : 'Deactivated'}
            </CBadge>
          </td>
        ),
        actions: (item) => (
          <td className="py-2">
            {item.is_active === 1 ? (
              <CButton
                size="sm"
                color="dark"
                variant="outline"
                onClick={() => handleStatus(item.id, 0)}
                disabled={loading}
              >
                Deactivate
              </CButton>
            ) : (
              <CButton
                size="sm"
                color="success"
                variant="outline"
                onClick={() => handleStatus(item.id, 1)}
                disabled={loading}
              >
                Activate
              </CButton>
            )}
          </td>
        ),
      }}
      items={users?.data}
      itemsPerPage={itemsPerPage}
      itemsPerPageSelect
      loading={loading}
      pagination={{
        external: true,
      }}
      paginationProps={{
        activePage: activePage,
        pages: Math.ceil(users?.total / itemsPerPage) || 1,
      }}
      tableProps={{
        hover: true,
        responsive: true,
      }}
      onActivePageChange={(activePage) => setActivePage(activePage)}
      onColumnFilterChange={(filter) => {
        setActivePage(1)
        setColumnFilter(filter)
      }}
      onItemsPerPageChange={(itemsPerPage) => {
        setActivePage(1)
        setItemsPerPage(itemsPerPage)
      }}
      onSorterChange={(sorter) => setColumnSorter(sorter)}
    />
  )
}

export default GamePromoTable
